import { Observable } from 'rxjs';
import { ApiService, GET_MY_GAMES_PATH, GetMyGamesResponse } from '@core-http';

export class MyGamesService extends ApiService {
  getMyGames(): Observable<GetMyGamesResponse> {
    return this.httpClient.get<GetMyGamesResponse>(`${this.env.apiUrl}${GET_MY_GAMES_PATH}`);
  }
}
